module.exports = __webpack_public_path__ + "static/Gallery-1-e5dc78abd2fab515a4472581f360d040.jpg";